export function formatFollowers(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

// Compact integer-style follower count: 21 / 937 / 2k / 29k / 187k / 2.1M / 15.3M.
// Lowercase k for thousands (no decimals), uppercase M for millions (1 decimal
// only when not integer). Used in stats columns and the new ManyChat creator
// found message.
function trimZeroDecimal(s: string): string {
  return s.replace(/\.0$/, '');
}

export function formatCompactFollowers(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '0';
  if (n < 1_000) return String(Math.round(n));
  if (n < 1_000_000) return `${Math.round(n / 1_000)}k`;
  return `${trimZeroDecimal((n / 1_000_000).toFixed(1))}M`;
}

export function formatCurrency(n: number): string {
  const fixed = n.toFixed(2);
  const trimmed = fixed.replace(/\.?0+$/, '');
  return `$${trimmed}`;
}

const RANK_RANGES: Record<number, string> = {
  1: '0-499',
  2: '500-1K',
  3: '1K-5K',
  4: '5K-10K',
  5: '10K-25K',
  6: '25K-50K',
  7: '50K-100K',
  8: '100K-250K',
  9: '250K-500K',
  10: '500K-750K',
  11: '>750K',
};

export function rankToFollowerRange(rank: number): string {
  return RANK_RANGES[rank] ?? `Rank ${rank}`;
}

type Named = { first_name?: string; last_name?: string; ig_username: string };

export function displayName(u: Named): string {
  const full = [u.first_name, u.last_name].filter(Boolean).join(' ');
  return full || u.ig_username;
}

export function formatDate(d: string): string {
  return new Date(d).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}
